import { render, staticRenderFns } from "./OnboardingEdit.vue?vue&type=template&id=4061965e&scoped=true"
import script from "./OnboardingEdit.vue?vue&type=script&lang=ts"
export * from "./OnboardingEdit.vue?vue&type=script&lang=ts"
import style0 from "./OnboardingEdit.vue?vue&type=style&index=0&id=4061965e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4061965e",
  null
  
)

export default component.exports